let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fbAMm")).then(() => parcelRequire('eyKC3'));